// libs
import React, { useState, useRef } from 'react';
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTrash } from '@fortawesome/free-solid-svg-icons';
import "../../assets/css/form.css";
import "react-datepicker/dist/react-datepicker.css";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
// components 
import Loading from '../../components/loading';
import GalleryBox from '../../components/gallery-box';
import ImagePreview from '../../components/image-preview-box';
import specKeys from '../../components/sepc-keys';
// config & functions 
import ajaxCall from '../../utils/ajaxcall';
import config from "../../config/index";
import { formatSizeLabel } from '../../utils/size-label';
import { parseApiRecords } from '../../utils/parse-api-records';

function FormModal({loadapidata, apidataparams, urlaccountid, urlaccountdomain, setshowformmodalbox, rowid, token, orginfo}) {

    const [InputFields, setInputFields] = useState({
        accountId: "",
        statusId: "",
        rowId: "",
        productName: "",
        productImg: "",
        description: "",
        specConfig: "",
        metaConfig: "",
        quantity: "",
        skuId: "",
        colorId: "",
        sizeId: "",
        categoryId: "",
        identifierExists: "true",
        listingPrice: ""
    });
    const [CategoryList, setCategoryList] = useState([]);
    const disabledField = (orginfo.roleId === 1 || orginfo.roleId === 2) ? false:true;
    const [SubmitButton, setSubmitButton] = useState((rowid) ? 'UPDATE RECORD' : 'SAVE RECORD');
    const [Notification, setNotification] = useState({ status: (rowid) ? true : false, message: 'Please wait while we fetch your record' })
    const [DisableSubmitButton, setDisableSubmitButton] = useState(false);
    const [ColorList, setColorList] = useState([]);
    const [SizeList, setSizeList] = useState([]);
    const [StatusList, setStatusList] = useState([]);
    const [BrowseImage, setBrowseImage] = useState(false);
    const [PreviewImage, setPreviewImage] = useState(false);
    const [PreviewImagePath, setPreviewImagePath] = useState(false);
    const [Show, setShow] = useState(false);

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
        reset
    } = useForm();
    const { fields:specList, append:appendSpecList, remove:removeSpecList } = useFieldArray({
        control,
        name: "items"
    });


    const handleViewImage = (status, imgName) => {
        if(urlaccountdomain) {
            setPreviewImagePath(`${config.assets.products}/sas-ecommerce/${urlaccountdomain}/products/large/${imgName}`);
            setPreviewImage(status);
        } else {
            toast.error('Invalid seller account or waiting for account values');
        }
    }

    const hideModal = () => {
        setShow(false);
        setshowformmodalbox(false)
	}

    const updateChangeEvent = (e, field) => {
		const v = e && e.target != null ? e.target.value : e;
		field.onChange(v);
	}

    const handleInputState = ((key, val) => {
        const newData = { ...InputFields }
        newData[key] = val
        setInputFields(newData)
    })

    const removeProductImage = (i) => {
        const imgArrList = (InputFields.productImg) ? InputFields.productImg.split(",") : null;
        if(imgArrList.length > 0) {
            imgArrList.splice(i,1);
        }
        handleInputState('productImg', imgArrList.join()) 
    }

    const handleProductImageName=((val)=>{ 
        handleInputState('productImg', val) 
    })

    const onSubmit = async (data) => {
        setSubmitButton('LOADING...');
        setDisableSubmitButton(true);
        let postData = {
            rowId: rowid,
            accountId: urlaccountid,
            statusId: data.statusId,
            productName: data.productName,
            productImg: InputFields.productImg,
            description: data.description,
            specConfig: JSON.stringify(data.items),
            metaConfig: data.metaConfig,
            quantity: (rowid) ? '' : data.quantity,
            skuId: (rowid) ? '' : data.skuId,
            colorId: (rowid) ? '' : data.colorId,
            sizeId: (rowid) ? '' : data.sizeId,
            mrp: (rowid) ? '' : data.mrp,
            listingPrice: (rowid) ? '' : data.listingPrice,
            categoryId: data.categoryId || "",
            identifierExists: data.identifierExists !== "false",
        }
        let apiCall = "";
        if(InputFields.rowId) {
            apiCall = await ajaxCall.patchCall(`${config.api.generic}/inventory`, postData, token);
        } else {
            apiCall = await ajaxCall.postCall(`${config.api.generic}/inventory`, postData, token);
        }
        if(apiCall && apiCall.status) {
            setSubmitButton((InputFields.rowId)?'UPDATE RECORD':'SAVE RECORD');
            toast.info('Record updated successfully');
            reset();
            setDisableSubmitButton(false);
            loadapidata(apidataparams); // refresh list page
        } else {
            setSubmitButton((InputFields.rowId)?'UPDATE RECORD':'SAVE RECORD');
            toast.error(apiCall && apiCall.context.message || 'Something went wrong. Please try again :(');
            setDisableSubmitButton(false);
        }
    }
    
    const fetchColorList = async () => {
        let apiCall = await ajaxCall.getCall(`${config.api.generic}/color`, {}, token);
        if (apiCall && apiCall.status) {
            setColorList(parseApiRecords(apiCall));
        } else {
            setColorList([]);
        }
    }

    const fetchSizeList = async () => {
        if (!urlaccountid) {
            setSizeList([]);
            return;
        }
        let apiCall = await ajaxCall.getCall(`${config.api.generic}/size`, { fAccount: urlaccountid }, token);
        if (apiCall && apiCall.status && apiCall.context.message.data?.records) {
            setSizeList(apiCall.context.message.data.records);
        } else {
            setSizeList([]);
        }
    }

    const fetchStatusList = async () => {
        let apiCall = await ajaxCall.getCall(`${config.api.generic}/inventory/status`, {}, token);
        if(apiCall && apiCall.status) {
            setStatusList(apiCall.context.message.data);
        }
    }

    const fetchCategoryList = async () => {
        if (!urlaccountid) {
            setCategoryList([]);
            return;
        }
        let apiCall = await ajaxCall.getCall(`${config.api.generic}/category`, { fAccount: urlaccountid }, token);
        if (apiCall && apiCall.status && apiCall.context.message.data?.records) {
            setCategoryList(apiCall.context.message.data.records);
        } else {
            setCategoryList([]);
        }
    }

    // Get data from DB - Used for Edit option
    React.useEffect(() => {
        async function loadComponent() {
            setShow(true);
        }

        const safeJsonParse = (str) => {
            if (!str) return null;
            const sanitized = str.replace(/[\n\r\t]/g, (ch) => {
                if (ch === '\n') return '\\n';
                if (ch === '\r') return '\\r';
                if (ch === '\t') return '\\t';
                return ch;
            });
            return JSON.parse(sanitized);
        };

        async function fetchData() {
            if (rowid) {
                let apiCall = await ajaxCall.getCall(`${config.api.generic}/inventory/row`, {
                    rowId: (rowid) ? rowid : 0
                }, token);
                if(apiCall && apiCall.status) {
                    let onLoadData = {
                        rowId: rowid,
                        statusId: apiCall.context.message.data[0].fk_inventory_status_id,
                        productName: apiCall.context.message.data[0].product_name,
                        productImg: apiCall.context.message.data[0].product_image,
                        description: apiCall.context.message.data[0].description,
                        specConfig: safeJsonParse(apiCall.context.message.data[0].specification),
                        metaConfig: apiCall.context.message.data[0].meta_config,
                        quantity: "",
                        skuId: "",
                        colorId: "",
                        sizeId: "",
                        categoryId: apiCall.context.message.data[0].fk_product_category_id
                            ? String(apiCall.context.message.data[0].fk_product_category_id)
                            : "",
                        identifierExists: Number(apiCall.context.message.data[0].identifier_exists) === 0 ? "false" : "true",
                        mrp: "",
                        listingPrice: ""
                    }
                    appendSpecList(safeJsonParse(apiCall.context.message.data[0].specification))
                    setInputFields(onLoadData)
                    setNotification({ status: false })
                } else {
                    setNotification({ status: true, message: 'Sorry something went wrong while fetching record :(' })
                }
            } else {
                appendSpecList({ key: "", value: "" })
            }
        }
        fetchData();
        fetchColorList();
        fetchStatusList();
        fetchSizeList();
        fetchCategoryList();
        loadComponent();
    }, [urlaccountid]);

    const imgArrList = (InputFields.productImg) ? InputFields.productImg.split(",") : null;

    return (
        <>
            <Modal show={Show} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header>
                    <Modal.Title>{rowid?'Update Inventory Record':'Add Inventory Record'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <form action="" method="" className="p-sm-1" onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                    {(Notification.status) ? <Col md="12" className="text-center">{Notification.message}</Col> : <>
                                        <Col md="12">
                                            <div className="text-left mt-3 vt-txt-dark-blue">
                                                <h4><b>Inventory Info</b></h4>
                                                <hr />
                                            </div>
                                        </Col>
                                        <Col md="6" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Status</label>
                                            <Controller
                                                name='statusId' 
                                                defaultValue={InputFields.statusId}
                                                rules={{required: true}}
                                                control={control} 
                                                render={({field}) => (
                                                    <select value={field.value || ""} className="form-control custom-select" name="statusId" onChange={(e) => {updateChangeEvent(e, field)}} disabled={disabledField}>
                                                        <option value=""> Choose...</option>
                                                        {(Array.isArray(StatusList) && StatusList.length > 0) ? StatusList.map(d => {
                                                            return <option key={Math.random()} value={d.pk_id}>{d.label}</option>
                                                        }):null}
                                                    </select>
                                                )}
                                            />	
                                            <small className="form-text text-danger">
                                                {errors.statusId?.type === "required" && "Please update status"}
                                            </small>
                                        </Col>
                                        <Col md="6" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Category</label>
                                            <Controller
                                                name='categoryId'
                                                defaultValue={InputFields.categoryId}
                                                rules={{required: false}}
                                                control={control}
                                                render={({field}) => (
                                                    <select
                                                        value={field.value || ""}
                                                        className="form-control custom-select"
                                                        name="categoryId"
                                                        onChange={(e) => {
                                                            updateChangeEvent(e, field);
                                                            handleInputState('categoryId', e.target.value);
                                                        }}
                                                        disabled={disabledField || !urlaccountid}
                                                    >
                                                        <option value="">Choose...</option>
                                                        {(Array.isArray(CategoryList) && CategoryList.length > 0) ? CategoryList.map(d => (
                                                            <option key={d.pk_id} value={d.pk_id}>{d.parent_label ? `${d.parent_label} › ${d.label}` : d.label}</option>
                                                        )) : null}
                                                    </select>
                                                )}
                                            />
                                            <small className="form-text text-muted">
                                                Manage categories on the <a href="/categories" target="_blank" rel="noreferrer">Categories</a> page.
                                            </small>
                                        </Col>
                                        <Col md="12" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Identifier Exists (Google Shopping)</label>
                                            <Controller
                                                name='identifierExists'
                                                defaultValue={InputFields.identifierExists}
                                                control={control}
                                                render={({field}) => (
                                                    <select value={field.value || "true"} className="form-control custom-select" name="identifierExists" onChange={(e) => {updateChangeEvent(e, field)}} disabled={disabledField}>
                                                        <option value="true">True</option>
                                                        <option value="false">False</option>
                                                    </select>
                                                )}
                                            />
                                            <small className="form-text text-muted">Set False for products without a GTIN/MPN/brand.</small>
                                        </Col>
                                        <Col md="12" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Product Name</label>
                                            <input type="text" defaultValue={InputFields.productName} className="form-control" name="productName" {...register("productName", { required: true, minLength: 1, maxLength: 122 })} disabled={disabledField} />
                                            <small className="form-text text-danger">
                                                {errors.productName?.type === "required" && "Product Name is mandatory"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.productName?.type === "minLength" && "Enter atleast 1 characters"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.productName?.type === "maxLength" && "Only 122 characters allowed"}
                                            </small>
                                        </Col>
                                        <Col md="12" className="mt-3">
                                            <Button variant="primary" type="button" className="btn btn-sm btn-primary" onClick={() => setBrowseImage(true)}>Browse Gallery</Button>
                                            <div className="mt-2">
                                                {(imgArrList && Array.isArray(imgArrList) && imgArrList.length > 0)? imgArrList.map((d,i) => {
                                                    return <span className="me-2 border border-2 rounded py-1 px-2" key={Math.random()}>{d} <FontAwesomeIcon icon={faSearch} onClick={e => handleViewImage(true, d)} className="dashboard-card-icon text-primay cursor-pointer" /> {(orginfo.roleId === 1 || orginfo.roleId === 3) ? <FontAwesomeIcon icon={faTrash} onClick={e => removeProductImage(i)} className="dashboard-card-icon text-danger" /> : null}</span>
                                                }):null}
                                            </div>
                                        </Col>
                                        <Col md="12" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Description</label>
                                            <textarea defaultValue={InputFields.description} className="form-control" name="description" {...register("description", { required: false, minLength: 5, maxLength: 500 })} disabled={disabledField}></textarea>
                                            <small className="form-text text-danger">
                                                {errors.description?.type === "required" && "Description is mandatory"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.description?.type === "minLength" && "Enter atleast 5 characters"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.description?.type === "maxLength" && "Only 500 characters allowed"}
                                            </small>
                                        </Col>
                                        <Col md="12" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Specification</label>
                                        </Col>
                                        <Col md="12">
                                            {(specList && Array.isArray(specList) && specList.length > 0) ? 
                                                specList.map((field, index) => {
                                                    return <div key={field.pk_id} className="row border-bottom">
                                                        <div className={`col-12 ${(orginfo.roleId === 1 || orginfo.roleId == 3) ? `col-lg-5` : `col-lg-6`} mt-2 mb-2`}>
                                                            <Controller
                                                                name={`items[${index}].key`}
                                                                defaultValue={field.key}
                                                                rules={{required: true}}
                                                                control={control} 
                                                                render={({field}) => (
                                                                    <select value={field.value} className="form-control custom-select" onChange={(e) => {updateChangeEvent(e, field)}} disabled={disabledField}>
                                                                        <option value=""></option>
                                                                        {specKeys && (Object.keys(specKeys).length > 0) ? Object.keys(specKeys).map((d,i) => {
                                                                            return <option key={Math.random()} value={Object.keys(specKeys)[i]}>{specKeys[Object.keys(specKeys)[i]]}</option>
                                                                        }):null}
                                                                    </select>
                                                                )}
                                                            />
                                                            <small className="form-text text-danger">
                                                                {errors.items && errors.items[index] && errors.items[index].key && errors.items[index]?.key.type === "required" && "Please update key"}
                                                            </small>
                                                        </div>
                                                        <div className={`col-12 ${(orginfo.roleId === 1 || orginfo.roleId == 3) ? `col-lg-5` : `col-lg-6`} mt-2 mb-2`}>
                                                            <input type="text" {...register(`items[${index}].value`, { required: true })} defaultValue={field.value} className="form-control"  disabled={disabledField} />
                                                            <small className="form-text text-danger">
                                                                {errors.items && errors.items[index] && errors.items[index].value && errors.items[index]?.value.type === "required" && "Please update value"}
                                                            </small>
                                                        </div>
                                                        {(orginfo.roleId === 1 || orginfo.roleId === 3) ? <div className="col-12 col-lg-2 mt-2 mb-2 text-center d-flex justify-item-center align-items-start">
                                                            {(specList.length > 1)?<Button variant="light" type="button" className="fs-14rem border-danger text-danger me-2" onClick={() => removeSpecList(index)}>-</Button>:null}
                                                            <Button variant="light" type="button" className="fs-14rem border-dark text-dark" onClick={() => appendSpecList({ key: "", value: "" })}>+</Button>
                                                        </div> : null}
                                                    </div>
                                                })
                                            :null}
                                        </Col>
                                        <Col md="12" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Meta Tag Config</label>
                                            <textarea defaultValue={InputFields.metaConfig} rows="5" className="form-control" name="metaConfig" {...register("metaConfig", { required: true, minLength: 5, maxLength: 800 })} disabled={disabledField}></textarea>
                                            <small className="form-text text-danger">
                                                {errors.metaConfig?.type === "required" && "Meta tags is mandatory"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.metaConfig?.type === "minLength" && "Enter atleast 5 characters"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.metaConfig?.type === "maxLength" && "Only 800 characters allowed"}
                                            </small>
                                        </Col>
                                        <Col md="12" className={`mt-3 ${rowid?`d-none`:``}`}>
                                            <div className="text-left mt-3 vt-txt-dark-blue">
                                                <h4><b>Variant Info</b></h4>
                                                <hr />
                                            </div>
                                        </Col>
                                        <Col md="4" className={`mt-3 ${rowid?`d-none`:``}`}>
                                            <label className="form-label fs-14rem fw-bold">Color</label>
                                            <Controller
                                                name='colorId' 
                                                defaultValue={InputFields.colorId}
                                                rules={{required: false}}
                                                control={control} 
                                                render={({field}) => (
                                                    <select value={field.value || ""} className="form-control custom-select" name="colorId" onChange={(e) => {updateChangeEvent(e, field)}} disabled={rowid?true:false}>
                                                        <option value=""> Choose...</option>
                                                        {(Array.isArray(ColorList) && ColorList.length > 0) ? ColorList.map(d => {
                                                            return <option key={Math.random()} value={d.pk_id}>{d.label}</option>
                                                        }):null}
                                                    </select>
                                                )}
                                            />	
                                            <small className="form-text text-muted">
                                                Manage colors on the <a href="/colors" target="_blank" rel="noreferrer">Colors</a> page.
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.colorId?.type === "required" && "Please update color"}
                                            </small>
                                        </Col>
                                        <Col md="4" className={`mt-3 ${rowid?`d-none`:``}`}>
                                            <label className="form-label fs-14rem fw-bold">Size</label>
                                            <Controller
                                                name='sizeId' 
                                                defaultValue={InputFields.sizeId}
                                                rules={{required: false}}
                                                control={control} 
                                                render={({field}) => (
                                                    <select value={field.value || ""} className="form-control custom-select" name="sizeId" onChange={(e) => {updateChangeEvent(e, field)}} disabled={rowid?true:!urlaccountid}>
                                                        <option value=""> Choose...</option>
                                                        {(Array.isArray(SizeList) && SizeList.length > 0) ? SizeList.map(d => {
                                                            return <option key={d.pk_id} value={d.pk_id}>{formatSizeLabel(d)}</option>
                                                        }):null}
                                                    </select>
                                                )}
                                            />	
                                            <small className="form-text text-muted">
                                                Manage sizes on the <a href="/sizes" target="_blank" rel="noreferrer">Sizes</a> page.
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.sizeId?.type === "required" && "Please update size"}
                                            </small>
                                        </Col>
                                        <Col md="4" className={`mt-3 ${rowid?`d-none`:``}`}>
                                            <label className="form-label fs-14rem fw-bold">SKU Id</label>
                                            <input type="text" defaultValue={InputFields.skuId} className="form-control" name="skuId" {...register("skuId", { required: rowid?false:true, minLength: 1, maxLength: 125 })} disabled={rowid?true:false} />
                                            <small className="form-text text-danger">
                                                {errors.skuId?.type === "required" && "Sku Id is mandatory"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.skuId?.type === "minLength" && "Enter atleast 1 characters"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.skuId?.type === "maxLength" && "Only 125 characters allowed"}
                                            </small>
                                        </Col>
                                        <Col md="4" className={`mt-3 ${rowid?`d-none`:``}`}>
                                            <label className="form-label fs-14rem fw-bold">Quantity</label>
                                            <input type="text" defaultValue={InputFields.quantity} className="form-control" name="quantity" {...register("quantity", { required: rowid?false:true, minLength: 1, maxLength: 7 })} disabled={rowid?true:false} />
                                            <small className="form-text text-danger">
                                                {errors.quantity?.type === "required" && "Quantity is mandatory"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.quantity?.type === "minLength" && "Enter atleast 1 characters"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.quantity?.type === "maxLength" && "Only 7 characters allowed"}
                                            </small>
                                        </Col>
                                        <Col md="4" className={`mt-3 ${rowid?`d-none`:``}`}>
                                            <label className="form-label fs-14rem fw-bold">MRP</label>
                                            <input type="text" defaultValue={InputFields.mrp} className="form-control" name="mrp" {...register("mrp", { required: rowid?false:true, minLength: 1, maxLength: 5 })} disabled={rowid?true:false} />
                                            <small className="form-text text-danger">
                                                {errors.mrp?.type === "required" && "MRP is mandatory"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.mrp?.type === "minLength" && "Enter atleast 1 characters"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.mrp?.type === "maxLength" && "Only 5 characters allowed"}
                                            </small>
                                        </Col>
                                        <Col md="4" className={`mt-3 ${rowid?`d-none`:``}`}>
                                            <label className="form-label fs-14rem fw-bold">Listing Price</label>
                                            <input type="text" defaultValue={InputFields.listingPrice} className="form-control" name="listingPrice" {...register("listingPrice", { required: rowid?false:true, minLength: 1, maxLength: 5 })} disabled={rowid?true:false} />
                                            <small className="form-text text-danger">
                                                {errors.listingPrice?.type === "required" && "Listing price is mandatory"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.listingPrice?.type === "minLength" && "Enter atleast 1 characters"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.listingPrice?.type === "maxLength" && "Only 5 characters allowed"}
                                            </small>
                                        </Col>
                                        {(orginfo.roleId === 1 || orginfo.roleId === 2) ? <Col md="12" className="text-end">
                                            <Button variant="primary" type="submit" disabled={DisableSubmitButton} className="vt-primary-btn border-0 text-end text-white mt-4 fs-14rem">{SubmitButton}</Button>
                                        </Col> : null }
                                    </>}
                                </Row>
                            </form>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="fs-14rem" onClick={hideModal}>Close</Button>
                </Modal.Footer>
            </Modal>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            {(BrowseImage)? <GalleryBox orgInfo={orginfo} handlegalleryimagenamefn={handleProductImageName} setbrowseimage={setBrowseImage} selectedimg={InputFields.productImg} token={token} action="selectable" />:null}
            {(PreviewImage)? <ImagePreview imagepath={PreviewImagePath} handleviewimagefn={handleViewImage} />:null}
        </>
    )
}

export default FormModal;